import generatePathWithParams from "helpers/generatePathWithParams";
import prefixPathWithBasePath from "helpers/prefixPathWithBasePath";

export const jobsTabSegments = {
  myFilters: "matching-my-filters",
  allPaid: "all-paid",
  allOpportunities: "all-opportunities",
  clientAlerts: "client-alerts",
  selfTapeRequests: "self-tape-requests",
  mySuggestions: "my-suggestions",
};

export class ApplicationMap {
  private urls = {
    jobs: {
      index: `/:tab(${jobsTabSegments.myFilters}|${jobsTabSegments.allPaid}|${jobsTabSegments.allOpportunities}|${jobsTabSegments.clientAlerts}|${jobsTabSegments.selfTapeRequests}|${jobsTabSegments.mySuggestions})`,
      myFilters: `/${jobsTabSegments.myFilters}`,
      allPaid: `/${jobsTabSegments.allPaid}`,
      allOpportunities: `/${jobsTabSegments.allOpportunities}`,
      clientAlerts: `/${jobsTabSegments.clientAlerts}`,
      selfTapeRequests: `/${jobsTabSegments.selfTapeRequests}`,
      mySuggestions: `/${jobsTabSegments.mySuggestions}`,
    },
    job: {
      index: "/breakdowns",
      breakdown: "/breakdowns/:breakdownId",
      breakdownPrint: "/breakdowns/:breakdownId/print",
      role: "/breakdowns/:breakdownId/role/:roleId",
      followUp: "/breakdowns/:breakdownId/follow-up-message/:followUpId",
    },
    selfTapeUpload: "/self-tape-requests/:performerRequestId/add-video",
    selfTapeRequest: "/self-tape-requests/:performerRequestId",
    agentSearch: "/performers/search/:searchTerm?",
  };

  public routes = {
    jobs: () => prefixPathWithBasePath(this.urls.jobs.index),
    jobsMyFilters: () => prefixPathWithBasePath(this.urls.jobs.myFilters),
    jobsAllPaid: () => prefixPathWithBasePath(this.urls.jobs.allPaid),
    jobsAllOpportunities: () =>
      prefixPathWithBasePath(this.urls.jobs.allOpportunities),
    jobsClientAlerts: () => prefixPathWithBasePath(this.urls.jobs.clientAlerts),
    jobsSelfTapeRequests: () =>
      prefixPathWithBasePath(this.urls.jobs.selfTapeRequests),
    jobsMySuggestions: () =>
      prefixPathWithBasePath(this.urls.jobs.mySuggestions),
    job: () => prefixPathWithBasePath(this.urls.job.index),
    jobBreakdown: () => prefixPathWithBasePath(this.urls.job.breakdown),
    jobBreakdownPrint: () =>
      prefixPathWithBasePath(this.urls.job.breakdownPrint),
    jobRole: () => prefixPathWithBasePath(this.urls.job.role),
    jobFollowUp: () => prefixPathWithBasePath(this.urls.job.followUp),
    selfTapeUpload: () => prefixPathWithBasePath(this.urls.selfTapeUpload),
    selfTapeRequest: () => prefixPathWithBasePath(this.urls.selfTapeRequest),
    agentSearch: () => prefixPathWithBasePath(this.urls.agentSearch),
  };

  public links = {
    jobsMyFilters: () => generatePathWithParams(this.urls.jobs.myFilters),
    jobsAllPaid: () => generatePathWithParams(this.urls.jobs.allPaid),
    jobsAllOpportunities: () =>
      generatePathWithParams(this.urls.jobs.allOpportunities),
    jobsClientAlerts: () => prefixPathWithBasePath(this.urls.jobs.clientAlerts),
    jobsSelfTapeRequests: () =>
      prefixPathWithBasePath(this.urls.jobs.selfTapeRequests),
    jobsMySuggestions: () =>
      prefixPathWithBasePath(this.urls.jobs.mySuggestions),
    jobBreakdown: (breakdownId: string) =>
      generatePathWithParams(this.urls.job.breakdown, { breakdownId }),
    jobBreakdownPrint: (breakdownId: string) =>
      generatePathWithParams(this.urls.job.breakdownPrint, { breakdownId }),
    jobRole: (breakdownId: string, roleId: string) =>
      generatePathWithParams(this.urls.job.role, { breakdownId, roleId }),
    jobFollowUp: (breakdownId: string, followUpId: string) =>
      generatePathWithParams(this.urls.job.followUp, {
        breakdownId,
        followUpId,
      }),
    selfTapeUpload: (performerRequestId: string) =>
      generatePathWithParams(this.urls.selfTapeUpload, { performerRequestId }),
    selfTapeRequest: (performerRequestId: string) =>
      generatePathWithParams(this.urls.selfTapeRequest, { performerRequestId }),
  };
}

export default new ApplicationMap();
